import gql from "graphql-tag";
import { contactDetailsFields } from "../queries/getContactDetails";
import { jobDetailsFields } from "../queries/getJob";
import { invoiceDetailsFields } from "../queries/getInvoice";

export const PERFORM_ACTION = gql`mutation PerformAction($performActionInput: PerformActionInput!) {
    performAction(performActionInput: $performActionInput) {
        ... on Contact {
            ${contactDetailsFields}
        }
        ... on Job {
            ${jobDetailsFields}
        }
        ... on Invoice {
            ${invoiceDetailsFields}
        }
    }
}`;
